// SkeletonLoading.jsx
import React from 'react';

// Base skeleton element with pulsing animation
const SkeletonElement = ({ className }) => {
  return <div className={`animate-pulse bg-gray-200 rounded ${className}`}></div>;
};

// Skeleton for a dashboard tile
export const DashboardTileSkeleton = () => {
  return (
    <div className="grid grid-cols-6 md:grid-cols-6 lg:grid-cols-12 gap-6">
      {/* Create 4 skeleton tiles */}
      {[...Array(4)].map((_, index) => (
        <div key={index} className="col-span-3 bg-white p-4 rounded-lg shadow">
          <SkeletonElement className="h-8 w-3/4 mb-4" />
          <SkeletonElement className="h-16 w-full mb-2" />
          <div className="flex justify-between items-center mt-4">
            <SkeletonElement className="h-6 w-1/4" />
            <SkeletonElement className="h-6 w-1/4" />
          </div>
        </div>
      ))}
    </div>
  );
};

// Skeleton for last inspection panels
export const LastInspectionSkeleton = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow h-full">
      {/* Header */}
      <SkeletonElement className="h-6 w-1/3 mb-4" />
      
      {/* Items */}
      {[...Array(5)].map((_, index) => (
        <div key={index} className="border-b border-gray-100 py-3">
          <div className="flex justify-between items-center mb-2">
            <SkeletonElement className="h-5 w-2/5" />
            <SkeletonElement className="h-5 w-1/4" />
          </div>
          <SkeletonElement className="h-4 w-3/4" />
        </div>
      ))}
      
      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <SkeletonElement className="h-8 w-1/3" />
      </div>
    </div>
  );
};

export default {
  DashboardTileSkeleton,
  LastInspectionSkeleton
};